import {Injectable, inject} from '@angular/core'
import {EmbeddedStoreService} from '@service/embeddingService/embedded-store.service'
import {TaxesService} from './taxes.service'

/**
 * Variante embebida de `TaxesService`.
 *
 * @description
 * Lee la configuración fiscal (`taxes`, `taxesProfiles`, `additionalCosts`) del payload
 * del host vía `EmbeddedStoreService.dataTaxes` en lugar de PouchDB.
 */
@Injectable({
  providedIn: 'root',
})
export class TaxesEmbeddedService extends TaxesService {
  private readonly orderEmbbdedStoreService = inject(EmbeddedStoreService)

  protected override getInfoTaxesData = async (): Promise<unknown> => this.orderEmbbdedStoreService.dataTaxes()
}
